import React from "react";
import { Typography, Box, CircularProgress } from "@mui/material";
import ArrowUpwardIcon from "../../../assets/images/ArrowUpwardIcon_green.svg";
import ArrowDownwardIcon from "../../../assets/images/ArrowDownwardIcon_red.svg";

import "../../../assets/css/SalesByZone/SalesStatsContainer.css";

import QuaterlyPerformance from "./QuaterlyPerformance";
import { useSalesContext } from "../../SalesContext";

const SalesStatsCard = ({ width, height, salesData, salesUnit }) => {
  return (
    <div
      style={{
        width: width,
        height: height,
        borderRadius: "8px",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        backgroundColor: "#E9F4FA",
        padding: "16px 12px",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: "26px" }}>
        <Box>
          <Typography
            sx={{ fontSize: "16px" }}
            fontWeight="bold"
            variant="body1"
          >
            YTD Sales ({salesUnit || "Lacs"})
          </Typography>
          <Box
            sx={{
              height: "2px",
              width: "100%",
              backgroundColor: "#A8BACC",
              marginTop: "12px",
              borderRadius: "1px",
            }}
          />
        </Box>
        {salesData.map((item, index) => {
          const isNegative = item.isPercentage && item.value < 0;
          const isPositive = item.isPercentage && item.value > 0;
          const isAchOrGrwLabel = item.label === "%Ach" || item.label === "Grw";

          return (
            <Box
              key={index}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "5px",
              }}
            >
              <Typography variant="body1" sx={{ fontSize: "14px" }}>
                {item.label}
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                {item.isPercentage && item.value !== 0 && (
                  <img
                    src={isNegative ? ArrowDownwardIcon : ArrowUpwardIcon}
                    alt={isNegative ? "down arrow" : "up arrow"}
                    style={{
                      width: "12px",
                      height: "12px",
                      marginRight: "4px",
                    }}
                  />
                )}
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: "bold",
                    color:
                      isAchOrGrwLabel && item.value !== 0
                        ? isNegative
                          ? "red"
                          : isPositive
                          ? "green"
                          : "black"
                        : "black",
                  }}
                >
                  {item.value}
                  {item.isPercentage && item.value !== 0 ? "%" : ""}
                </Typography>
              </Box>
            </Box>
          );
        })}
      </Box>
    </div>
  );
};

const SalesStatsContainer = () => {
  const { salesUnit, loading, kpiData } = useSalesContext();

  const getYesterdayDate = () => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const options = { day: "2-digit", month: "short", year: "2-digit" };
    return yesterday.toLocaleDateString("en-GB", options).replace(/ /g, "-");
  };

  if (loading || !kpiData) {
    return (
      <Box
        sx={{
          p: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  const card1Data = kpiData?.kpi_data?.cards_data?.card1_year_sale;
  const card2Data = kpiData?.kpi_data?.card2_data;

  const convertValue = (value, isPercentage) => {
    if (
      value === "-Infinity" ||
      value === "Infinity" ||
      isNaN(value) ||
      value === null ||
      value === undefined
    ) {
      return 0;
    }

    let convertedValue = Number(value);

    if (!isPercentage) {
      if (salesUnit === "Lacs") {
        convertedValue = convertedValue / 100000;
      } else if (salesUnit === "Crores") {
        convertedValue = convertedValue / 10000000;
      }
    }

    return Number(convertedValue.toFixed(2));
  };

  const salesData = [
    {
      label: "LYTD",
      value: convertValue(card1Data?.LYTD, false),
      isPercentage: false,
    },
    {
      label: "Target",
      value: convertValue(card1Data?.Target, false),
      isPercentage: false,
    },
    {
      label: "CYTD",
      value: convertValue(card1Data?.CYTD, false),
      isPercentage: false,
    },
    {
      label: "%Ach",
      value: convertValue(card1Data?.Percentage_Archive, true),
      isPercentage: true,
    },
    {
      label: "Grw",
      value: convertValue(card1Data?.Growth, true),
      isPercentage: true,
    },
  ];

  return (
    <Box className="SalesStats-container">
      <Box sx={{ width: "40%" }}>
        <Typography
          sx={{
            color: "#3f51b5",
            fontWeight: "600",
            marginBottom: "12px",
            fontSize: "18px",
          }}
        >
          Sales Status{" "}
          <span style={{ fontSize: "12px", fontWeight: 100 }}>
            {" "}
            Data Till Date {getYesterdayDate()}
          </span>
        </Typography>
        <SalesStatsCard
          height="355px"
          salesData={salesData}
          salesUnit={salesUnit}
        />
      </Box>

      <Box width="60%" height="386px" sx={{ marginLeft: "16px" }}>
        <Typography
          sx={{
            color: "#3f51b5",
            fontWeight: "600",
            marginBottom: "12px",
            fontSize: "18px",
          }}
        >
          Quarterly Performance ({salesUnit || "Lacs"})
        </Typography>
        <QuaterlyPerformance card2Data={card2Data} />
      </Box>
    </Box>
  );
};

export default SalesStatsContainer;
